// extracted by mini-css-extract-plugin
module.exports = {"selectControl":"WorkersFilter_selectControl__XlxVK","boxContainer":"WorkersFilter_boxContainer__ecd9t","btn":"WorkersFilter_btn__gIrsc","isActive":"WorkersFilter_isActive__0huib"};